import {ServerStyleObject} from './styles.model';
import {IActJson} from '../../diagram-data/diagram-json-handler.service';
import {MAPS_TYPES_ENUM} from '../../editor-interface/shared/models/map.model';
import {ARCHITECTURE_TYPES} from '../../core/services/diagram-type-config.service';

function calculateFontStyle(styles: ServerStyleObject): number {
  const x = styles.fontBold ? 1 : 0;
  const y = styles.fontItalic ? 2 : 0;
  const z = styles.fontUnderline ? 4 : 0;

  return x + y + z;
}

function getActivityMinWH(
  json: IActJson,
  type: MAPS_TYPES_ENUM
): {minWidth: number; minHeight: number} {
  let minWidth;
  let minHeight;
  const visibleResourcesCount = (json?.resources || []).reduce(
    (acc, curr) => (curr.hidden || curr.main ? acc : ++acc),
    0
  );

  if (ARCHITECTURE_TYPES.includes(type)) {
    minWidth = getSFAMinWidth(json.resourcesPerRow, visibleResourcesCount);
    minHeight = getSFAMinResourceHeight(json.resourcesPerRow, visibleResourcesCount);
    minHeight = minHeight + (json?.footerText ? 35 + 15 : 0);
    minHeight = minHeight + (json?.footerText || visibleResourcesCount ? 20 : 0);
    minHeight = minHeight + (json?.attributes || []).length * 26;
  } else {
    minWidth = 100;
    minHeight = 72 + visibleResourcesCount * 24;
  }

  return {minWidth, minHeight};
}

function getSFAMinWidth(rowSize: number, visibleResources: number): number {
  const SFA_MIN_WIDTH = 120;
  const SFA_RESOURCE_SIZE = 40;
  const MARGIN_CORRELATION = 14;

  rowSize = rowSize ?? 0;
  const maxResourcesPerRow =
    rowSize === 0 ? visibleResources : visibleResources > rowSize ? rowSize : visibleResources;

  return Math.max(SFA_MIN_WIDTH, maxResourcesPerRow * (SFA_RESOURCE_SIZE + MARGIN_CORRELATION));
}

function getSFAMinResourceHeight(rowSize: number, visibleResources: number): number {
  const SFA_RESOURCE_SIZE = 40;
  const SFA_TOP_MARGIN = 15;
  const SFA_RESOURCE_ROW_GAP = 10;
  const SFA_CARD_MIN_HEIGHT = 60;

  rowSize = rowSize ?? 0;
  let rowsNum;

  switch (true) {
    case visibleResources === 0:
      rowsNum = 0;
      break;

    case rowSize === 0:
      rowsNum = 1;
      break;

    default:
      rowsNum = Math.ceil(visibleResources / rowSize);
  }

  const rowGapsNum = rowsNum === 0 ? 0 : rowsNum - 1;
  const resourceSectionHeight =
    rowsNum * SFA_RESOURCE_SIZE + rowGapsNum * SFA_RESOURCE_ROW_GAP + SFA_TOP_MARGIN;

  return rowsNum ? SFA_CARD_MIN_HEIGHT + resourceSectionHeight : SFA_CARD_MIN_HEIGHT;
}

function fontCss(styles: ServerStyleObject): string {
  const result = {};

  result['font-family'] = styles.font;

  if (styles.fontColor) {
    result['color'] = styles.fontColor;
  }

  if (styles.fontSize) {
    result['font-size'] = styles.fontSize;
  }

  if (styles.fontBold) {
    result['font-weight'] = 'bold';
  }

  if (styles.fontItalic) {
    result['font-style'] = 'italic';
  }

  if (styles.fontUnderline) {
    result['text-decoration'] = 'underline';
  }

  return objectToString(result, ':');
}

function objectToString(object, connector): string {
  let result = '';

  connector = connector ? connector : '=';

  Object.keys(object).forEach(styleKey => {
    let keyValue = '';

    keyValue += styleKey;

    if (object[styleKey] !== null) {
      keyValue += connector + object[styleKey] + ';';
    } else {
      keyValue += ';';
    }

    result += keyValue;
  });

  if (result[result.length - 1] === ';') {
    result = result.substring(0, result.length - 1);
  }

  return result;
}

export {calculateFontStyle, fontCss, objectToString, getActivityMinWH};
